import React, { useEffect, useState } from 'react'
import AppLayout from '../../../../layout/components/AppLayout'
import DateSelect from '../../../../components/AppInput/DateSelect';
import useSystemMasterList from '../../../../hooks/useSystemMasterList';
import reportsServices from '../reportsServices';
import StatusCounterByType from '../components/StatusCounterByType';

function GrievanceStatusReportByTypePage() {
	const [masters,getMasterLabel] = useSystemMasterList(['grievance-type','grievance-status']);
	const [filter,setFilter] = useState(null);
	const [grievanceList,setGrievanceList] = useState(null);

	const getGreivanceList = () =>{
		if(masters){
			setGrievanceList(null);
			const payload = {
				startDate:filter.startDate,
				endDate:filter.endDate
			}
			reportsServices.getGrievanceByType(payload).then(res=>{
				setGrievanceList(res.data);
			}).catch(error=>{
			}).finally(()=>{
			})
		}
	}

	useEffect(()=>{
		getGreivanceList();
	},[filter,masters])

  return (
    <AppLayout>
		<div className='container-fluid'>
			<div className='row mb-3'>
                <div className='col-md-12'>
                    <div class="p-2 bg-dark text-center text-white rounded">
                        <h3 className='mb-0' >All Grievance</h3>
                    </div>
                </div>
            </div>
			<div className='row'>
				<div className='col-md-12'>
					<span className='float-end'><DateSelect filter={filter} setFilter={setFilter} /></span>
				</div>
			</div>
			<div className='row'>
				<div className='col-md-12'>
					{masters && grievanceList && 
						<StatusCounterByType reportData={grievanceList} masters={masters} getMasterLabel={getMasterLabel} />
					}
				</div>
			</div>
		</div>
    </AppLayout>
  )
}

export default GrievanceStatusReportByTypePage